/* eslint-disable @typescript-eslint/naming-convention */
import React, { ComponentType, ReactElement } from "react";
import { I18nWebview, IRapportWebPackage } from "./i18n-webview";
import { I18nConsumer } from "./i18n-context";

type OmittedTranslationProps<P> = Omit<P, keyof TranslationProps>;

type TranslationProps = {
  i18n: I18nWebview;
};

const getDisplayName = ({ displayName, name }: React.ComponentType): string => {
  return displayName || name
    ? `Translated(${displayName || name})`
    : "TranslatedComponent";
};

export const withTranslation = (rapportPackage?: IRapportWebPackage) => <
  // eslint-disable-next-line @typescript-eslint/ban-types
  P extends {}
>(
  Component: ComponentType<P>
): React.FC<OmittedTranslationProps<P>> => {
  const displayName = getDisplayName(Component);

  const ComponentWithTranslation = (
    props: OmittedTranslationProps<P>
  ): ReactElement => {
    return (
      <I18nConsumer>
        {({ i18n, locale }) => {
          if (rapportPackage) {
            i18n.extend(rapportPackage);
          }
          return <Component i18n={i18n} locale={locale} {...(props as P)} />;
        }}
      </I18nConsumer>
    );
  };

  ComponentWithTranslation.displayName = displayName;

  return ComponentWithTranslation;
};

export default withTranslation;
